import axios from "axios";
import { liveURL } from "../constants/Consts";

const MAIN_URL = `${liveURL}/v1/adminExibition`;
const CREATE_EXHIBITION = `${MAIN_URL}/createExhibition`;
const GET_EXHIBITIONS = `${MAIN_URL}/getExhibitions`;
const GET_EXHIBITION_BY_ID = `${MAIN_URL}/getExhibition`;
const UPDATE_EXHIBITION = `${MAIN_URL}/updateExhibition`;
const DELETE_EXHIBITION = `${MAIN_URL}/deleteExhibition`;

// Create a new exhibition
export async function createExhibition(token, data) {
  try {
    const response = await axios.post(CREATE_EXHIBITION, data, {
      headers: { token: token },
    });
    return response.data;
  } catch (error) {
    console.log("Error creating exhibition:", error);
    return { Result: false, Msg: "Error creating exhibition" };
  }
}

// Get all exhibitions
export async function getExhibitions(token) {
  try {
    const response = await axios.get(GET_EXHIBITIONS, {
      headers: { token: token },
    });
    return response.data;
  } catch (error) {
    console.log("Error fetching exhibitions:", error);
    return { Result: false, Msg: "Error fetching exhibitions" };
  }
}

// Get exhibition by ID
export async function getExhibitionById(token, id) {
  try {
    const response = await axios.get(`${GET_EXHIBITION_BY_ID}/${id}`, {
      headers: { token: token },
    });
    return response.data;
  } catch (error) {
    console.log("Error fetching exhibition by ID:", error);
    return { Result: false, Msg: "Error fetching exhibition" };
  }
}

// Update an existing exhibition
export async function updateExhibition(token, id, data) {
  try {
    const response = await axios.put(`${UPDATE_EXHIBITION}/${id}`, data, {
      headers: { token: token },
    });
    return response.data;
  } catch (error) {
    console.log("Error updating exhibition:", error);
    return { Result: false, Msg: "Error updating exhibition" };
  }
}

// Delete a exhibition
export async function deleteExhibition(token, id) {
  try {
    const response = await axios.delete(`${DELETE_EXHIBITION}/${id}`, {
      headers: { token: token },
    });
    return response.data;
  } catch (error) {
    console.log("Error deleting exhibition:", error);
    return { Result: false, Msg: "Error deleting exhibition" };
  }
}


const CREATE_EXHIBITION_CONTENT = `${MAIN_URL}/createExhibitionContent`;
const GET_EXHIBITION_CONTENTS = `${MAIN_URL}/getExhibitionContents`;
const GET_EXHIBITION_CONTENT_BY_ID = `${MAIN_URL}/getExhibitionContent`;
const UPDATE_EXHIBITION_CONTENT = `${MAIN_URL}/updateExhibitionContent`;
const DELETE_EXHIBITION_CONTENT = `${MAIN_URL}/deleteExhibitionContent`;

// Create a new exhibition content
export async function createExhibitionContent(token, data) {
  try {
    const response = await axios.post(CREATE_EXHIBITION_CONTENT, data, {
      headers: { token: token },
    });
    return response.data;
  } catch (error) {
    console.log("Error creating exhibition content:", error);
    return { Result: false, Msg: "Error creating exhibition content" };
  }
}

// Get all exhibition contents
export async function getExhibitionContents(token) {
  try {
    const response = await axios.get(GET_EXHIBITION_CONTENTS, {
      headers: { token: token },
    });
    return response.data;
  } catch (error) {
    console.log("Error fetching exhibition contents:", error);
    return { Result: false, Msg: "Error fetching exhibition contents" };
  }
}

// Get exhibition content by ID
export async function getExhibitionContentById(token, id) {
  try {
    const response = await axios.get(`${GET_EXHIBITION_CONTENT_BY_ID}/${id}`, {
      headers: { token: token },
    });
    return response.data;
  } catch (error) {
    console.log("Error fetching exhibition content by ID:", error);
    return { Result: false, Msg: "Error fetching exhibition content" };
  }
}

// Update an existing exhibition content
export async function updateExhibitionContent(token, id, data) {
  try {
    const response = await axios.put(`${UPDATE_EXHIBITION_CONTENT}/${id}`, data, {
      headers: { token: token },
    });
    return response.data;
  } catch (error) {
    console.log("Error updating exhibition content:", error);
    return { Result: false, Msg: "Error updating exhibition content" };
  }
}

// Delete a exhibition content
export async function deleteExhibitionContent(token, id) {
  try {
    const response = await axios.delete(`${DELETE_EXHIBITION_CONTENT}/${id}`, {
      headers: { token: token },
    });
    return response.data;
  } catch (error) {
    console.log("Error deleting exhibition content:", error);
    return { Result: false, Msg: "Error deleting exhibition content" };
  }
}